'use client';

import ArticleBrief from './ArticleBrief';
import { ICategoryOrTag, IPost } from '../../models/ICategory';
import { twMerge } from 'tailwind-merge';


const locales = {
  en: {
    loading: 'Loading',
    button: 'Read more',
  },
  ar: {
    button: 'شاهد المزيد',
    loading: 'تحميل'
  }
}

interface Props {
  initialData?: ICategoryOrTag;
  locale: string;
  mainTitle: string;
  categorySlug: string;
  mainPost: string;
  device?: string;
}

export default function RecommendedPosts({ initialData, locale, mainTitle, device }: Props) {
   
  return (
    <aside className='flex-1 desktop:min-w-[474px] desktop:max-w-[474px] tablet:sticky tablet:mt-[24px] tablet:pl-[16px] ltr:tablet:pl-0 desktop:pl-[74px] tablet:top-[125px] w-full bg-transparent flex flex-col h-fit bg-gradient-to-b from-transparent to-white tablet:bg-none dark:to-transparent rounded-br-[24px] rounded-bl-[24px] tablet:rounded-bl-none tablet:rounded-br-none recommended-posts'>

     {initialData?.posts?.data?.length ? <span className='h2 text-primary-300 px-[12px] tablet:px-0 mt-[16px] tablet:mt-0 tablet:text-center dark:text-white mb-[24px]'>{mainTitle}</span> : null}

      <div className='flex flex-col gap-y-[10px] [&>*:nth-child(n+5)]:hidden desktop:[&>*:nth-child(n+5)]:flex'>
        {initialData?.posts?.data?.map((p,i) => (
          <ArticleBrief
          customTitleEl={<p className={twMerge('whitespace-normal line-clamp-3', 'tablet:px-[12px] desktop:px-0 desktop:whitespace-pre-wrap md line-clamp-3 h3')}>{p.title}</p>}
            linkProps={{prefetch: false}}
            device={device}
            hideCategory
            hideMeta
            locale={locale}
            key={String(p.slug + i)}
            data={{
              post: {
                ...p,
                title: p.title,
                imageProps: {
                  fill: true,
                  sizes: '100vw',
                }
              },
              category: { title: p.category.title, slug: p.category.slug, uniqueCode: p.category.uniqueCode }
            }
            }
            className={{
              content: {
               title: 'tablet:px-[12px] desktop:px-0 desktop:whitespace-pre-wrap md line-clamp-3',
              },
              wrapper: 'desktop:flex-row desktop:items-center bg-transparent tablet:bg-white p-[8px] desktop:px-[12px] tablet:rounded-[20px] desktop:gap-x-[20px] desktop:h-[112px]',
              image: 'flex-shrink-0 aspect-square w-[122px] tablet:w-full desktop:w-[unset] rounded-[8px]'
            }}
          />
        ))}
      </div>
    </aside>
  )
}